const { combineReducers } = require("redux");
const { request_reduser } = require("./request_reduser");

const reduser = combineReducers({
    request_form : request_reduser
})

export default reduser